export const SAVE = 'stepRentalVehicle.SAVE';
export const VALUE_CHANGED = 'stepRentalVehicle.VALUE_CHANGED';
export const LOAD = 'stepRentalVehicle.VALUE_LOAD';
export const NEXT = 'stepRentalVehicle.NEXT';
export const RESET = 'stepRentalVehicle.RESET';



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepRentalVehicle/constants.js